import toaster from 'toasted-notes';

import 'toasted-notes/src/styles.css';
import './notification.scss';

const Notification = ({ message }) => toaster.notify(message);

export default Notification;
